import savedItemsSdkProvider from "../../../providers/savedItemsSdkProvider";
const {
  sorts: {
    SORTBY_DATE,
    SORTBY_DISCOUNT,
    SORTBY_PRICE,
    SORTBY_BRAND,
    SORTBY_STOCK,
    SORTBY_RECENTLY_DISCOUNTED
  },
  sortOrders: { SORT_ORDER_DESCENDING, SORT_ORDER_ASCENDING }
} = savedItemsSdkProvider();

// Sort
export {
  SORTBY_DATE,
  SORTBY_DISCOUNT,
  SORTBY_PRICE,
  SORTBY_BRAND,
  SORTBY_STOCK,
  SORTBY_RECENTLY_DISCOUNTED,
  SORT_ORDER_DESCENDING,
  SORT_ORDER_ASCENDING
};

// App Initialisation
export const LOADING_DATA_ON_PAGE_LOAD = "LOADING_DATA_ON_PAGE_LOAD";
export const RESET_INITIALISATION = "RESET_INITIALISATION";

// Action
export const BOARD_NOT_FOUND = "BOARD_NOT_FOUND";
export const BOARD_PAGE_NOT_FOUND = "BOARD_PAGE_NOT_FOUND";
export const DELETE_ITEM = "DELETE_ITEM";
export const DELETED_ITEM_SUCCESS = "DELETED_ITEM_SUCCESS";
export const DISMISS_WARNING = "DISMISS_WARNING";
export const LOAD_ITEMS = "LOAD_ITEMS";
export const LOAD_ITEMS_FAILURE = "LOAD_ITEMS_FAILURE";
export const ITEM_TO_BAG = "ITEM_TO_BAG";
export const ITEM_TO_BAG_SUCCESS = "ITEM_TO_BAG_SUCCESS";
export const PURGE_DUPLICATE_SAVED_ITEM = "PURGE_DUPLICATE_SAVED_ITEM";
export const RECEIVE_ITEMS = "RECEIVE_ITEMS";
export const RECEIVE_PAGINATION_ITEMS = "RECEIVE_PAGINATION_ITEMS";
export const RECEIVE_BOARD_DETAILS = "RECEIVE_BOARD_DETAILS";
export const RECEIVE_BOARD_SHARE_ID = "RECEIVE_BOARD_SHARE_ID";
export const SAVED_ITEMS_SDK_FAILURE = "SAVED_ITEMS_SDK_FAILURE";
export const SET_INITIAL_SORT = "SET_INITIAL_SORT";
export const SHOW_FULFILMENT_INFO = "SHOW_FULFILMENT_INFO";
export const SORT_INTENT = "SORT_INTENT";
export const SORT_FAILURE = "SORT_FAILURE";
export const SORT_SUCCESS = "SORT_SUCCESS";
export const UPDATE_ITEM = "UPDATE_ITEM";
export const UPDATE_ITEM_FAILURE = "UPDATE_ITEM_FAILURE";
export const UPDATE_ITEM_INTENT = "UPDATE_ITEM_INTENT";
export const UPDATE_ITEM_SUCCESS = "UPDATE_ITEM_SUCCESS";
export const SET_VARIANT_OUT_OF_STOCK = "SET_VARIANT_OUT_OF_STOCK";
export const SET_SORT_FOCUS = "SET_SORT_FOCUS";
export const GOOGLE_ADVERT_LOADED = "GOOGLE_ADVERT_LOADED";

// Back In Stock
export const SHOW_SUCCESS_BANNER = "SHOW_SUCCESS_BANNER";
export const SUCCESS_BANNER_OPT_IN_ALERT = "SUCCESS_BANNER_OPT_IN_ALERT";
export const SUCCESS_BANNER_PRIORITY_OPT_IN_ALERT =
  "SUCCESS_BANNER_PRIORITY_OPT_IN_ALERT";
export const SUCCESS_BANNER_OPT_OUT_ALERT = "SUCCESS_BANNER_OPT_OUT_ALERT";
export const SHOW_WARNING_BANNER = "SHOW_WARNING_BANNER";
export const SIZE_SELECT_ERROR = "SIZE_SELECT_ERROR";

// Pagination
export const INITIAL_ITEM_OFFSET = 0;
export const BATCH_SIZE = 50;
export const THRESHOLD_LIMIT = 40;

// Item State
export const ITEM_STATE_PLACEHOLDER = "ITEM_STATE_PLACEHOLDER";
export const ITEM_STATE_LOADING = "ITEM_STATE_LOADING";
export const ITEM_STATE_LOADING_FAILED = "ITEM_STATE_LOADING_FAILED";
export const ITEM_STATE_SAVED_ITEM_LOADED = "ITEM_STATE_SAVED_ITEM_LOADED";
export const ITEM_STATE_DELETING = "ITEM_STATE_DELETING";
export const ITEM_STATE_DELETED = "ITEM_STATE_DELETED";
export const ITEM_STATE_TO_BAG_IN_PROGRESS = "ITEM_STATE_TO_BAG_IN_PROGRESS";
export const ITEM_STATE_TO_BAG_COMPLETE = "ITEM_STATE_TO_BAG_COMPLETE";

// Error
export const ITEM_TO_BAG_ERROR_BRAND_QUANTITY_EXCEEDED =
  "ITEM_TO_BAG_ERROR_BRAND_QUANTITY_EXCEEDED";
export const ITEM_TO_BAG_ERROR_VOUCHER_IN_THE_BAG =
  "ITEM_TO_BAG__ERROR_VOUCHER_IN_THE_BAG";
export const ITEM_TO_BAG_ERROR_OUT_OF_STOCK = "ITEM_TO_BAG_ERROR_OUT_OF_STOCK";
export const ITEM_TO_BAG_ERROR_TIMEOUT = "ITEM_TO_BAG_ERROR_TIMEOUT";
export const ITEM_TO_BAG_ERROR_BAG_SIZE_EXCEEDED =
  "ITEM_TO_BAG_ERROR_BAG_SIZE_EXCEEDED";
export const ITEM_TO_BAG_ERROR_VARIANT_QUANTITY_EXCEEDED =
  "ITEM_TO_BAG_ERROR_VARIANT_QUANTITY_EXCEEDED";
export const GET_SAVED_ITEMS_REQUEST_TIMEOUT =
  "GET_SAVED_ITEMS_REQUEST_TIMEOUT";
export const GET_SHARED_ITEMS_REQUEST_TIMEOUT =
  "GET_SHARED_ITEMS_REQUEST_TIMEOUT";
